export enum BodyType {
  coupe = 'coupe',
  crossover = 'crossover',
  hatchback = 'hatchback',
  sedan = 'sedan',
  suv = 'suv',
  truck = 'truck',
  van = 'van',
  wagon = 'wagon',
  other = 'other',
  unknown = 'unknown',
}

export const BodyTypeValues: { [key in BodyType]: string } = {
  coupe: 'Coupe',
  crossover: 'Crossover',
  hatchback: 'Hatchback',
  sedan: 'Sedan',
  suv: 'SUV',
  truck: 'Truck',
  van: 'Van/Minivan',
  wagon: 'Wagon',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromBodyTypeValue = (value: string) => {
  switch (value) {
    case 'Coupe':
      return BodyType.coupe;
    case 'Crossover':
      return BodyType.crossover;
    case 'Hatchback':
      return BodyType.hatchback;
    case 'Sedan':
      return BodyType.sedan;
    case 'SUV':
      return BodyType.suv;
    case 'Truck':
      return BodyType.truck;
    case 'Van/Minivan':
      return BodyType.van;
    case 'Wagon':
      return BodyType.wagon;
    case 'Other':
      return BodyType.other;
    case 'Unknown':
      return BodyType.unknown;
    default:
      throw new Error(`invalid BodyType value: ${value}`);
  }
};
